// Validate repo name + visibility trước khi gọi `gh repo create`. Fail-fast với
// thông báo Vietnamese rõ ràng. GitHub repo name spec: alphanumeric, dash,
// underscore, dot. 1-100 chars.
const REPO_NAME_REGEX = /^[a-zA-Z0-9._-]{1,100}$/;

export type RepoVisibility = "private" | "public";

export class InvalidRepoNameError extends Error {
  constructor(name: string) {
    super(
      `Tên repo "${name}" không hợp lệ. Chỉ dùng chữ/số/dấu chấm/gạch/underscore, dài 1-100 ký tự.`,
    );
    this.name = "InvalidRepoNameError";
  }
}

export function validateRepoName(name: string): void {
  if (!REPO_NAME_REGEX.test(name)) {
    throw new InvalidRepoNameError(name);
  }
}

export function validateRepoVisibility(v: string): asserts v is RepoVisibility {
  if (v !== "private" && v !== "public") {
    throw new Error(`Visibility phải là "private" hoặc "public", nhận: "${v}"`);
  }
}
